import { render, staticRenderFns } from "./ActiveKillerPerks.vue?vue&type=template&id=752a2868"
import script from "./ActiveKillerPerks.vue?vue&type=script&lang=js"
export * from "./ActiveKillerPerks.vue?vue&type=script&lang=js"
import style0 from "./ActiveKillerPerks.vue?vue&type=style&index=0&id=752a2868&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports